import { AppBar, Toolbar, Typography, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { useThemeContext } from "../context/ThemeContext";
import useLayoutStore from "../store/useLayoutStore";
import { useState, useCallback, useMemo } from "react";
import ThemeConfigModal from "./ThemeConfigModal";
import { useLocation } from "react-router-dom";

// import lại menuItems giống Sidebar
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import CollectionsBookmarkRoundedIcon from "@mui/icons-material/CollectionsBookmarkRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import LocalOfferRoundedIcon from "@mui/icons-material/LocalOfferRounded";
import ArticleRoundedIcon from "@mui/icons-material/ArticleRounded";
import InsertChartRoundedIcon from "@mui/icons-material/InsertChartRounded";
import ConfirmationNumberRoundedIcon from "@mui/icons-material/ConfirmationNumberRounded";
import PhotoAlbumRoundedIcon from "@mui/icons-material/PhotoAlbumRounded";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import { useTranslation } from "react-i18next";

const clientUrl = process.env.REACT_APP_CLIENT_URL || "http://localhost:3000";

const drawerWidth = 240;
const collapsedWidth = 80;
const APPBAR_H = 64;

const Header = () => {
  const theme = useTheme();
  const { primaryColor } = useThemeContext();
  const { t } = useTranslation();
  const location = useLocation();

  // ✅ định nghĩa menuItems chung
  const menuItems = useMemo(() => [
    { text: t("Dashboard"), path: "/dashboard", icon: <DashboardRoundedIcon /> },
    { text: t("Products"), path: "/products", icon: <Inventory2RoundedIcon /> },
    { text: t("Collections"), path: "/collections", icon: <CollectionsBookmarkRoundedIcon /> },
    { text: t("Orders"), path: "/orders", icon: <ReceiptLongRoundedIcon /> },
    { text: t("Customers"), path: "/customers", icon: <PeopleAltRoundedIcon /> },
    { text: t("CMS"), path: "/cms", icon: <ArticleRoundedIcon /> },
    { text: t("Report"), path: "/reports", icon: <InsertChartRoundedIcon /> },
    { text: t("Promotions"), path: "/promotions", icon: <LocalOfferRoundedIcon /> },
    { text: t("Coupons"), path: "/coupons", icon: <ConfirmationNumberRoundedIcon /> },
    { text: t("Albums"), path: "/albums", icon: <PhotoAlbumRoundedIcon /> },
    { text: t("Sales"), path: "/sales", icon: <TrendingUpRoundedIcon /> },
  ], [t]);

  // ✅ tìm menuItem tương ứng với route hiện tại
  const currentMenu = menuItems.find((item) =>
    location.pathname.startsWith(item.path)
  );

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isDesktop = useMediaQuery(theme.breakpoints.between("lg", "xl"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("xl"));

  const { isSidebarOpen, toggleSidebar, toggleMobileSidebar } = useLayoutStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    sessionStorage.removeItem("token");
    window.location.href = `${clientUrl}/auth?tab=login`;
  };

  const handleMenuClick = useCallback(() => {
    if (isMobile || isTablet) toggleMobileSidebar();
    else toggleSidebar();
  }, [isMobile, isTablet, toggleMobileSidebar, toggleSidebar]);

  let drawerW = 0;
  if (isMobile) drawerW = 0;
  else if (isTablet) drawerW = 200;
  else if (isLaptop) drawerW = isSidebarOpen ? drawerWidth : collapsedWidth;
  else if (isDesktop) drawerW = isSidebarOpen ? 280 : 100;
  else if (isLargeScreen) drawerW = isSidebarOpen ? 320 : 120;

  const appBarSx =
    isMobile || isTablet
      ? { width: "100%", ml: 0 }
      : { width: `calc(100% - ${drawerW}px)`, ml: `${drawerW}px` };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          ...appBarSx,
          height: APPBAR_H,
          transition: "width 0.3s, margin-left 0.3s",
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.background.default
              : primaryColor,
          color: theme.palette.text.primary,
          zIndex: (t) => t.zIndex.drawer + 1,
        }}
      >
        <Toolbar sx={{ minHeight: APPBAR_H }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleMenuClick}
            sx={{ mr: 1 }}
          >
            <MenuIcon />
          </IconButton>

          {/* Thay đổi tiêu đề động theo menu hiện tại */}
          <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
            {currentMenu ? currentMenu.text : "Admin Dashboard"}
          </Typography>

          <IconButton
            color="inherit"
            onClick={() => setIsModalOpen(true)}
            title="Cài đặt giao diện"
          >
            <SettingsIcon />
          </IconButton>

          <IconButton color="inherit" onClick={handleLogout} title="Đăng xuất">
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <ThemeConfigModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Header;
